import Header from "./components/Header";
import Hero from "./components/Hero";
import RankingBoard from "./components/RankingBoard";
import CategoryGrid from "./components/CategoryGrid";
import HotPicks from "./components/HotPicks";
import SpecialFeature from "./components/SpecialFeature";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs } from "@/mocks/trends";

function JsonLd({ data }: { data: object }) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export default function Home() {
  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "吃瓜合集",
    url: "https://zhty6.cn/",
    logo: "https://readdy.ai/api/search-image?query=minimal%20fire%20logo%20mark%20in%20flat%20red%20orange%20with%20rounded%20square%20background%2C%20modern%20brand%20icon&width=512&height=512&seq=logo-x1&orientation=squarish",
    description: "聚合全网热点讨论的热度资讯平台，实时热搜与热度排行。",
  };

  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <JsonLd data={orgLd} />
      <JsonLd data={faqLd} />
      <Header />
      <main>
        <Hero />
        <RankingBoard />
        <CategoryGrid />
        <SpecialFeature />
        <HotPicks />
        <About />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}